module.exports = __webpack_public_path__ + "img/jr28.65d63164.jpg";